import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import App from './App';
import './sentry';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { SettingsProvider } from './settings/SettingsContext';
import { TenantProvider } from './settings/TenantContext';
import reportWebVitals from './reportWebVitals';
import { installHomelessInterceptor } from './lib/homelessInterceptor';

installHomelessInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TenantProvider>
          <SettingsProvider>
            <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
              <App />
            </Sentry.ErrorBoundary>
          </SettingsProvider>
        </TenantProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Signal that the SPA has mounted so static shell can be hidden
try {
  window.__SPA_MOUNTED = true;
  window.dispatchEvent(new Event('spa:mounted'));
} catch (e) {}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
